<div class="flex-row flex">
    <div class="flex-col flex">
        @if (editingComment) {
            <mat-form-field class="flex"
                            [ngClass]="{'cb-soft-required': softRequired && !required }">
                <mat-label>{{ label }}</mat-label>
                <textarea matInput
                          [name]="internalName"
                          type="text"
                          [(ngModel)]="value"
                          [required]="required"
                          [maxlength]="maxlength || 1000"
                          [rows]="rows || 5">
        </textarea>
            </mat-form-field>
        }
        @if (!editingComment) {
            <cb-display-value-new
                [label]="label"
                [value]="value"></cb-display-value-new>
        }
        @if (editingComment) {
            <div class="end-start flex-row"
            >
                <span>{{ getCharCount() }}</span>
            </div>
        }
        @if (editingComment) {
            <div class="cb-margin-top end-end flex-row"
            >
                <button mat-stroked-button
                        class="cb-margin-right"
                        color="accent"
                        (click)="saveComment()">
                    Save
                </button>
                <button mat-stroked-button
                        (click)="cancelComment()">
                    Cancel
                </button>
            </div>
        }
    </div>
    <div class="cb-margin-left center-center flex-col">
        @if (!editingComment && !isEditDisabled) {
            <button mat-icon-button
                    (click)="editComment()">
                <mat-icon>edit</mat-icon>
            </button>
        }
    </div>
</div>
